<template>

  <van-action-sheet v-model="isShow" title="服务列表">

    <!--搜索-->
    <div>
      <van-search
              v-model="search"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              :clearable="false"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>

    <!--列表-->
    <div class="service-box">
      <div class="service-list" v-for="(item, index) in filterServiceList" :key="index">
        <div class="s-l">
          <img v-if="item.pic" :src="fileDisplayPrefix + item.pic"/>
          <img v-else src="@/assets/服务默认.png" />
          <span>
                <h2>{{item.name}}</h2>
                <p>{{item.price + '元/' + getDictName(goodUnitOptions, item.goodUnit)}}</p>
                <p>{{item.introduct}}</p>
              </span>
        </div>
        <div class="s-r">
          <span class="jian" @click="subtract(index)">-</span>
          <span class="mum">
            <!--<input style="border: 1px solid" type="number" v-model="item.num" />-->
            <van-field v-model="item.num" type="number" :maxlength="6" :formatter="formatter" input-align="center"/>
          </span>
          <span class="jia" @click="add(index)"> +</span>
        </div>
      </div>
    </div>

    <div class="b-but">
      <button @click="submit()">确认</button>
    </div>


  </van-action-sheet>

</template>

<script>
  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {getDictByType} from '@/api/common'
  import {getDictName} from '@/utils/common'
  import {queryList} from '@/api/service/service'

  export default {
    name: 'ServiceCart',
    components: {},
    data() {
      return {
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        getDictName,
        isShow: false,
        goodUnitOptions: [],
        queryParams: {},
        search: '',
        serviceList: [],
        filterServiceList: [],
        initList: []
      }
    },
    computed: {},
    created() {
      this.refresh()

      getDictByType('good_unit').then(res => {
        if (res.result) {
          this.goodUnitOptions = res.result.map(item => {
            return {label: item.dictKey, value: item.dictValue}
          })
        }
      })
    },
    mounted() {
    },
    watch: {
      search: function (val) {
        if (val) {
          this.filterServiceList = this.serviceList.filter(i => i.name.indexOf(this.queryParams.name) > -1)
        } else {
          this.filterServiceList = this.serviceList
        }
      },
    },
    methods: {
      formatter(e) {
        return parseInt(e)
      },
      show(list) {
        this.initData(list)
        this.isShow = true
      },
      initData(list = []) {
        this.initList = list

        const data = {}
        this.initList.forEach(i => data[i.id] = i.num)

        this.serviceList.forEach(s => s.num = data[s.id] || 0)
        this.filterServiceList = this.serviceList
        this.$forceUpdate()
      },
      refresh() {
        this.serviceList = []
        this.getList()
      },
      getList() {
        this.queryParams.size = -1
        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            this.serviceList = res.result.records
            this.initData(this.initList)
          }
        }).finally(() => {
        })
      },
      onSearch() {
        // this.refresh()
      },
      add(index) {
        if (this.serviceList[index].num) {
          this.serviceList[index].num++
        } else {
          this.serviceList[index].num = 1
        }
        this.$forceUpdate()
      },
      subtract(index) {
        if (!this.serviceList[index].num || this.serviceList[index].num <= 1) {
          this.serviceList[index].num = 0
        } else {
          this.serviceList[index].num--
        }
        this.$forceUpdate()
      },
      submit() {
        const data = this.serviceList.filter(i => i.num > 0)
        this.$emit('handleOk', JSON.parse(JSON.stringify(data)))
        this.isShow = false
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .van-cell {
    padding: 0;
  }
  .service-box {
    padding: 0 10px;
  }

  .service-list {
    display: flex;
    background: #ffffff;
    border-bottom: 1px solid #dedede;
    /*height: 90px;*/
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
  }

  .s-r {
    width: 130px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .s-r span {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
  }

  .s-r span.jia {
    background: #2C68E4;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    width: 24px;
  }

  .s-r span.jian {
    background: #ffffff;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    width: 24px;
    border: 2px solid #4F73FD;
    font-weight: bold;
  }

  .s-r span.mum {
    width: 65px;
    font-size: 16px;
  }

  .s-l {
    display: flex;
    flex: 1;
  }

  .s-l img {
    width: 56px;
    height: 56px;
    display: flex;
    margin-right: 5px;
  }

  .s-l span {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
  }

  .s-l span h2 {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin-bottom: 8px;
  }

  .s-l span p {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-bottom: 8px;
    line-height: 16px;
  }

  .service-box {
    max-height: 50vh;
    overflow-y: auto;
  }
</style>
